export default class MissingPrimaryVariantError extends Error {
};
